import {
  FETCH_ALL_FUNCTIONS_REQUEST,
  FETCH_ALL_FUNCTIONS_SUCCESS,
  FETCH_ALL_FUNCTIONS_ERROR,
  FETCH_FUNCTIONS_FOR_TEMPLATE_ID_REQUEST,
  FETCH_FUNCTIONS_FOR_TEMPLATE_ID_SUCCESS,
  FETCH_FUNCTIONS_FOR_TEMPLATE_ID_ERROR,
} from "../actions";

import { FunctionsActions } from "../actionCreators";

const initialState = false;

const isFetchingReducer = (
  state = initialState,
  action: FunctionsActions
): boolean => {
  switch (action.type) {
    case FETCH_ALL_FUNCTIONS_REQUEST:
    case FETCH_FUNCTIONS_FOR_TEMPLATE_ID_REQUEST:
      return true;

    case FETCH_ALL_FUNCTIONS_SUCCESS:
    case FETCH_ALL_FUNCTIONS_ERROR:
    case FETCH_FUNCTIONS_FOR_TEMPLATE_ID_SUCCESS:
    case FETCH_FUNCTIONS_FOR_TEMPLATE_ID_ERROR:
      return false;

    default:
      return state;
  }
};

export default isFetchingReducer;
